module.exports = __webpack_public_path__ + "static/media/buzzer-game-show1.df89aff1.aac";